const DrgInfo = ({drgData,setDrgData,selectedVersion,setSelectedVersion, typeOfPatient }) => {
  const versionObj = drgData?.drgs?.find(item => item[selectedVersion]);

const selectedDrgVersion = versionObj?.[selectedVersion];

// safely extract drg/weight
const drgValue = selectedDrgVersion?.drg ?? "N/A";
const weightValue = selectedDrgVersion?.weight ?? "";
const reimbursementValue = selectedDrgVersion?.reimbursement ?? "N/A";
const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
const HideTheweightandReimbursementsanEnv = process.env.REACT_APP_FLAG_SAN;

  console.log(typeOfPatient, 'typeOfPatient')
  return (
    <div>
      {typeOfPatient !== "outPatient" && !HideTheweightandReimbursementsanEnv&&
      <div
        className={`codingscreen-values-wrapper ${
          ["960Z", "961Z", "963Z"].includes(drgValue) ? "red-background" : ""
        }`}
      >
        <div className="error-wrapper">
          {!["960Z", "961Z", "963Z"].includes(drgValue) && (
            <label className="px-1">DRG </label>
          )}
          <label
            className={`val-bold ${
              ["960Z", "961Z", "963Z"].includes(drgValue) ? "text-red-500" : ""
            }`}
          >
            {drgValue}
          </label>
          {drgValue === "960Z" && (
            <span
              title="Ungroupable"
              style={{ color: "black", fontWeight: "bold" }}
              className="px-1"
            >
              Ungroupable
            </span>
          )}
          {drgValue === "961Z" && (
            <span
              title="Unacceptable Principal Diagnosis"
              style={{ color: "black", fontWeight: "bold" }}
              className="px-1"
            >
              Unacceptable Principal Diagnosis
            </span>
          )}
          {drgValue === "963Z" && (
            <span
              title="Neonatal Diagnosis Not Consistent W Age/Weight"
              style={{ color: "black", fontWeight: "bold" }}
              className="px-1"
            >
              Neonatal Diagnosis Not Consistent W Age/Weight
            </span>
          )}
        </div>
        <div>
          <label>Weight</label>
          {weightValue === "can't determine" ? (
            <span className="px-1">-</span>
          ) : (
            <span className="px-1">
              {weightValue && weightValue?.toFixed(4)}
            </span>
          )}
        </div>
       <div>
          <label>Reimbursement</label>
          {weightValue === "can't determine" ? (
            <span className="px-1">-</span>
          ) : (
            <span className="px-1">
              {codebookusaEnv
  ? Math.round(reimbursementValue).toLocaleString()
  : `$${Math.round(weightValue * 6465).toLocaleString()}`}
            </span>
          )}
        </div>
      </div>
      }
    </div>
  );
};

export default DrgInfo;
